var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('quill-editor',{attrs:{"content":_vm.content,"options":_vm.editorOption},on:{"change":function($event){return _vm.onEditorChange($event)}}}),_c('v-switch',{staticClass:"mt-4",attrs:{"label":"Admin Only","hide-details":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }